import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

enum Accion { Listar, Guardar }

@Component({
  selector: 'app-rol-parametro-autonomia',
  templateUrl: './rol-parametro-autonomia.component.html',
})
export class RolParametroAutonomiaComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() titlePage: string;
  @Input() data: any;

  accion: Accion;

  constructor() { }

  ngOnInit() {
    this.accion = Accion.Listar;
  }

  onSave(value: any) {
    this.data = value;
    this.accion = Accion.Guardar;
  }

  onListar() {
    this.accion = Accion.Listar;
  }
}
